<template>
  <div class="fc-data-source">
    <el-select
      v-model="innerValue"
      :disabled="disabled"
      :multiple="multiple"
      :clearable="clearable"
      :placeholder="placeholder"
      :filterable="filterable"
      style="width: 100%"
    >
      <el-option
        v-for="(item, index) in DsData"
        :label="item.label"
        :value="item.value"
        :key="index"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { execModel } from "@/api/core/data/datasource/model";
import { watch } from "less";
import { create } from "lodash";
import { h } from "vue";
export default {
  name: "fc-data-source",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Array],
      default: "",
    },
    dsConf_dstid: {
      type: [String, Number],
      default: "",
    },
    dsConf_dst_label: {
      type: String,
      default: "",
    },
    dsConf_dst_value: {
      type: String,
      default: "",
    },

    defaultValue: {
      type: [String, Array],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dsConf_dstid: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
    },
    innerValue (val) {
      this.$emit('input', val)
    },
    dsConf_dst_label(val) {
      if (val && this.dsConf_dst_value && !this.defaultValue) {
        this.getDsData();
      }
    },
    dsConf_dst_value(val) {
      if (val && this.dsConf_dst_label && !this.defaultValue) {
        this.getDsData();
      }
    },
    defaultValue: {
      handler(val){
        this.innerValue = val;
      },deep:true,
      immediate:true,     
      
    },
  },
  data() {
    return {
      DsData: [],
      list: [],
      innerValue: "",
    };
  },
  created() {
    if (this.dsConf_dstid) {
      this.getList();
    }
  },

  methods: {
    getList() {
      execModel(
        this.dsConf_dstid,
        JSON.stringify({ __max_count__: 9999 })
      ).then((res) => {
        this.list = res.data;
        if (this.dsConf_dst_value && this.dsConf_dst_label) {
          this.getDsData();
        }
      });
    },
    getDsData() {
      let dsConf_dst_label = this.dsConf_dst_label.split(":")[0];
      let dsConf_dst_value = this.dsConf_dst_value.split(":")[0];
      this.DsData = this.list.map((o) => {
        return {
          label: o[dsConf_dst_label],
          value: o[dsConf_dst_value],
        };
      });
    },
  },
};
</script>
<style lang="scss"></style>
